<div class="menu-container" [@slide]="(menu$ | async) ? 'slideIn' : ''">
  <ul class="menu">
    <li class="nav-close-button py-2 pr-2">
      <fa-icon class="m-2" [icon]="['fas','times']" (click)="closeMenu()"></fa-icon>
    </li>
    <ng-container *ngFor="let route of routes">
      <ng-container *ngIf="route.childrens; else noChildren">
        <li *ngIf="!route.disabled" class="nav-item" dropdown>
          <a class="nav-link" dropdownToggle data-toggle="dropdown" aria-expanded="false">
            <span> {{ ( route.labelPrefix ? (route.labelPrefix + '.' + route.label) 
              : route.label ) | translate}}</span>
            <fa-icon class="ml-1" [icon]="['fas', 'angle-down']"></fa-icon>
          </a>
          <div class="dropdown-menu" *dropdownMenu>
            <ng-container *ngFor="let children of route.childrens">
        <li *ngIf="!children.disabled" routerLinkActive="selected">
          <a class="nav-link" routerLinkActive="selected" routerLinkActive="active" [routerLink]="children.route"
            (click)="closeMenu()">
            <span> {{ ( route.labelPrefix ? (route.labelPrefix + '.' + children.label) 
              : children.label ) | translate}}</span>
          </a>
        </li>
      </ng-container>
</div>
</li>
</ng-container>
<ng-template #noChildren>
  <li *ngIf="!route.disabled" routerLinkActive="selected">
    <a class="nav-link" routerLinkActive="selected" routerLinkActive="active" [routerLink]="route.route"
      (click)="closeMenu()"><span>
        {{(route.labelPrefix ? (route.labelPrefix + '.' + route.label) : route.label ) | translate}}</span></a>
  </li>
</ng-template>
</ng-container>
</ul>
</div>
<div *ngIf="(menu$ | async)" class="menu-vail" (click)="closeMenu()"></div>